/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-layout-padding-left',
  templateUrl: './theme-option-layout-padding-left.component.html',
  styleUrls: ['./theme-option-layout-padding-left.component.css']
})
export class ThemeOptionLayoutPaddingLeftComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  showDetails: boolean;
  optionType: ThemeOptionType = 'layout_padding_left';

  constructor() {}

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  receiveValue(value: number, type?: ChartType) {
    this.themeOptions.setOption(this.optionType, value, type ? [type] : undefined);
  }

}
